export const usernameMinLength = 4;
export const passwordMinLength = 4;

export const onlyNumbersRegex = /^\d+$/i;

export const emptyString = '';
